"use server";

import { queryTable, exportTable, type CrmContactRow, type TableFilters } from "@/lib/query";
import { CRM_COLUMNS } from "./columns";

export async function fetchCrmContacts(filters: TableFilters, page: number, pageSize: number) {
  return queryTable<CrmContactRow>("yhdmro_crm_cust_contact_change", filters, page, pageSize);
}

export async function exportCrmContacts(filters: TableFilters) {
  return exportTable("yhdmro_crm_cust_contact_change", CRM_COLUMNS, filters);
}